import {Component, computed, inject, input, output, ChangeDetectionStrategy} from '@angular/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {map} from 'rxjs';


import {BreakpointObserver} from "@angular/cdk/layout";
import {TranslatePipe} from "@ngx-translate/core";
import {IconButtonComponent} from 'src/app/modules/design-system/icon-button/icon-button.component';
import {TextButtonComponent} from 'src/app/modules/design-system/text-button/text-button.component';

@Component({
  selector: 'app-onboarding-step-5',
  standalone: true,
	imports: [IconButtonComponent, TextButtonComponent, TranslatePipe],
  templateUrl: './onboarding-step-5.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: '../onboarding.component.scss'
})
export class OnboardingStep5Component {
	readonly stepCount = input.required<number>();
	readonly isMobile = input.required<boolean>();

	readonly onNextClick = output<string>();
	readonly onDismiss = output<undefined>();

	closeLoading = false;

	private readonly compact = toSignal(inject(BreakpointObserver).observe(['(max-width: 1280px)']).pipe(map(state => state.matches)), {initialValue: false});
	protected readonly panelClass = computed(() => this.compact() ? '' : 'big-button');
}
